import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  defaultIcon: {
    height: Theme.px(36),
    marginTop: Theme.px(4),
    width: Theme.px(36),
  },
});
